import { BgisSearchDetailBody, BgisSearchDetailEntry } from "../../bgis/components/maparea/sidebar/details"
import { useAppDispatch, useAppSelector } from "../hooks";
import { searchStyle, searchLayer } from "../layers";
import { zoomTo } from "../redux/slice/mapSlice";
import { selectSearchResult } from '../redux/slice/searchSlice';

export const SearchDetailBody = () => {

    const showSearchDetails = useAppSelector(state => state.search.isShowDetails);
    const searchResults = useAppSelector(state => state.search.results ? state.search.results : []);

    const dispatch = useAppDispatch();



    if (showSearchDetails) {

        // zoom to the extent of the search results 
        if (searchLayer.getSource()?.getExtent()) {
            dispatch(zoomTo(searchLayer.getSource()?.getExtent()));
        }

        return (<BgisSearchDetailBody>
            {searchResults.map(searchResult =>
                <BgisSearchDetailEntry
                    key={searchResult.id}
                    onMouseEnter={e => { searchLayer.setStyle(searchStyle(searchResult.id)); return false; }}
                    onMouseLeave={e => { searchLayer.setStyle(searchStyle()); return false; }}
                    onMouseUp={e => { dispatch(selectSearchResult(searchResult.id)); dispatch(zoomTo(searchResult.extent)); return false; }}
                >
                    <span className="bgis-title">{searchResult.label}</span>
                    <span className="bgis-caption">{searchResult.layer}</span>
                </BgisSearchDetailEntry>
            )}
            {searchResults.length === 0 && (<span className="bgis-grow">Keine Treffer gefunden </span>)}
        </BgisSearchDetailBody>)
    } else {
        return (
            <></>)
    }
}